import React from "react"
import ReactApexChart from "react-apexcharts";
import style from "./style.module.scss";
import {Tooltip} from "@material-ui/core";
import {Info} from "@material-ui/icons";
import {NavLink} from "react-router-dom";
import {useTheme} from "@material-ui/core/styles";
import {useTranslation} from "react-i18next";
import { useSelector } from "react-redux";
import { isObjectEmpty } from "../../../utils";
import { useChartStyles } from "../utils"
import config from "../../../config"

export default function ColumnChart({height, series, chartId, mainText, mean, max, min, withNavLink}) {
    const {theme: {bgColors, colors}} = useTheme();
    const {t} = useTranslation();
    const resultList2 = useSelector(state => state.dashboardData.resultList[1] || {});
    const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
    const isContrast = themeState !== config.THEMES_MODES.LIGHT
    const isDark = themeState === config.THEMES_MODES.CONTRAST_DARK
    useChartStyles(bgColors, colors)()

    const contrastFillTypes = (series || []).map(({colorName}) => colorName === config.BAR_TYPE.WARNING ? 'pattern' : 'solid')
    const contrastPatternStyles = (series || []).map(({colorName}) => colorName === config.BAR_TYPE.WARNING ? 'verticalLines' : 'squares')
    const contrastStrokeColors = (series || []).map(({colorName}) => colorName === config.BAR_TYPE.ERROR ? 'black' : colorName === config.BAR_TYPE.WARNING ? 'black' : 'transparent')
    const contrastStrokeWidths = (series || []).map(({colorName}) => colorName === config.BAR_TYPE.ERROR ? 2 : colorName === config.BAR_TYPE.WARNING ? 1 : 0)

    const options = {
        tooltip: {
            marker: {
                show: false
            },
            theme: isDark ? 'dark' : 'light'
        },
        chart: {
            height,
            id: chartId,
            type: 'bar'
        },
        plotOptions: {
            bar: {
                columnWidth: '100%'
            }
        },
        zoom: {
            enabled: true,
            type: 'x',
            autoScaleYaxis: false,
        },
        legend: {
            show: false
        },
        xaxis: {
            type: 'numeric',
            labels: {
                show: false
            }
        },
        yaxis: {
            max, min,
            labels: {
                style: { colors: colors.colorText },
            }
        },
        dataLabels: {
            enabled: false
        },
        ...(isContrast ? {
            fill: {
                type: contrastFillTypes,
                opacity: 1,
                pattern: {
                    style: contrastPatternStyles,
                    width: 8,
                    strokeWidth: 6,
                }
            },
            stroke: {
                show: true,
                colors: contrastStrokeColors,
                width: contrastStrokeWidths,
            }
        } : {})
    }

    return (
        <div className={`${style.RadialBar}`} style={{backgroundColor: bgColors.bgPrimary0}}>
            <div style={{marginBottom: "0%"}}>
                <div className={`d-flex justify-content-between pb-2 align-items-center ${style.withBorder}`}>
                    <h2 className={`m-0 ${style.withoutBorder} p-0`}
                        style={{color: colors.colorText}}>{chartId}</h2>
                    <Tooltip title={<h6 style={{fontSize: "15px"}}>{mainText}</h6>} className='ml-2 mr-auto'>
                        <Info style={{fill: colors.colorIcons}}/>
                    </Tooltip>
                    <div style={{color: colors.colorMutedText}}>{t('mean value')} {mean}</div>
                </div>
                <div className={`w-100`}>
                    <ReactApexChart  width='100%' options={options} series={series} type="bar" height={350} />
                </div>
            </div>
            {(withNavLink && !isObjectEmpty(resultList2)) && <div className={`${style.footer}`}>
                <NavLink to={withNavLink}>
                    <button style={{color: colors.colorText}}>{t("Detail view")}</button>
                </NavLink>
            </div>}
        </div>
    );
}
